/**
 * NotFoundPage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 *
 * NOTE: while this component should technically be a stateless functional
 * component (SFC), hot reloading does not currently support SFCs. If hot
 * reloading is not a necessity for you then you can refactor it and remove
 * the linting exception.
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Typography from '../../kingpin/atoms/Typography';
import appRoutes from '../../navigation/appRoutes';
import FlexCentered from '../../components/Common/FlexCentered';

const NotFoundPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(
      () => {
        navigate(appRoutes.home);
      },
      process.env.NODE_ENV === 'test' ? 10 : 2500,
    );
  }, [navigate]);

  return (
    <FlexCentered>
      <Typography.Header type="H1">
        Page not found, redirecting...
      </Typography.Header>
    </FlexCentered>
  );
};

export default NotFoundPage;
